'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.panelStyles = undefined;
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var _componentThemes$pane = _themes.componentThemes.panel,
  panelStyle = _componentThemes$pane.panelStyle,
  panelTheme = _componentThemes$pane.panelTheme;
var panelStyles = exports.panelStyles = function panelStyles(props) {
  var theme = panelTheme(props.theme);
  var mdPadding = function mdPadding() {
    if (props.noPadding) return 0;
    if (props.condensed) return theme.space_sm;
    return theme.space_md;
  };
  return Object.assign({
    margin: '0 0 ' + theme.space_md
  }, props.noBorder ? {} : {
    borderWidth: theme[panelStyle('borderWidth')],
    borderStyle: theme[panelStyle('borderStyle')],
    borderColor: theme[panelStyle('borderColor')]
  }, _defineProperty({
    borderRadius: theme[panelStyle('borderRadius')],
    backgroundColor: theme[panelStyle('backgroundColor')],
    padding: props.noPadding ? 0 : theme.space_sm
  }, (0, _themes.atLeast)(theme.breakpoint_md), {
    padding: mdPadding(),
    fontSize: props.condensed ? theme.fontSize : 'inherit'
  }));
};
exports.default = (0, _glamorous2.default)('div')(panelStyles);